/*
 * Filename: \src\Settings\Vendors\DuplicateVendor.js
 * Created Date: 2026-03-25 14:14
 * Author: John Kohl
 * 
 * Copyright (c) 2026 Logical Developments
 */


export default function DuplicateVendor({ selectedVendor, vendors }) {
  const originalVendor = vendors.find((vendor) => vendor.id === selectedVendor.permissions.duplicateId);

  return (
    <div class="stack">
      <h3>Duplicate Vendor Entry</h3>
      {originalVendor?.name
        ? (<><p>
          You are already linked to this vendor - see {originalVendor.name}.<br />
          This is likely because someone in your organisation added a vendor using a different name and sent it to {originalVendor.name}.
        </p>
          <p>
            You should delete this entry.
          </p>
        </>)
        : (<p>
          This vendor was a duplicate of another vendor that has since been removed. You should delete this entry.
        </p>)}
    </div>
  )
}